module.exports = __webpack_public_path__ + "assets/img/jiaonao.94f07479.png";